import { NavLink, Outlet, useParams } from "react-router-dom";
import { usePartnerPortalBase } from "./PartnerPortalBaseProvider";
import "../../styles/partnerDealers.css";

export default function PartnerDealerWorkspace() {
  const { dealerId } = useParams();
  const { path } = usePartnerPortalBase();

  return (
    <div className="partner-dealer-workspace">
      <nav className="partner-dealer-workspace__tabs" aria-label="Dealer management">
        <NavLink
          to={path(`dealers/${dealerId}`)}
          className={({ isActive }) =>
            `partner-dealer-workspace__tab${isActive ? " is-active" : ""}`
          }
          end
        >
          Account
        </NavLink>
        <NavLink
          to={path(`dealers/${dealerId}/inventory`)}
          className={({ isActive }) =>
            `partner-dealer-workspace__tab${isActive ? " is-active" : ""}`
          }
          end
        >
          Inventory
        </NavLink>
        <NavLink
          to={path(`dealers/${dealerId}/inventory/normalization`)}
          className={({ isActive }) =>
            `partner-dealer-workspace__tab${isActive ? " is-active" : ""}`
          }
        >
          Vehicle name matching
        </NavLink>
        <NavLink
          to={path(`dealers/${dealerId}/account`)}
          className={({ isActive }) =>
            `partner-dealer-workspace__tab${isActive ? " is-active" : ""}`
          }
          end
        >
          Dealer portal
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
